import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { FLITCH_INVENTORY_ISSUE_ORDER } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-loaded component pages
const FlitchInventoryList = lazy(() => import("app/pages/Inventory/Flitch-Inventory/ListFlitch"));
const AddFlitchStock = lazy(() => import("app/pages/Inventory/Flitch-Inventory/AddFlitch"));
const EditFlitchStock = lazy(() => import("app/pages/Inventory/Flitch-Inventory/EditFlitch"));
const ViewDetails = lazy(() => import("app/pages/Inventory/Flitch-Inventory/ListFlitch/Approval/ViewDetails"));
const FlitchIssueOrder = lazy(() => import("app/pages/Inventory/Flitch-Inventory/FlitchIssueOrder"));

// ✅ Static route configuration
export const flitchInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "flitch_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/flitch",
        element: LoadablePage(FlitchInventoryList),
      },
      {
        path: "/inventory/flitch/add",
        element: LoadablePage(AddFlitchStock),
      },
      {
        path: "/inventory/flitch/edit",
        element: LoadablePage(EditFlitchStock),
      },
      {
        path: "/inventory/flitch-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: FLITCH_INVENTORY_ISSUE_ORDER,
        element: LoadablePage(FlitchIssueOrder),
      },
    ],
  },
];
